// CANONICAL COPY (GH #7115). src/constants/obligations/obl-incident-learning.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-incident-learning',
  title: 'Review lessons learned from incidents',
  description:
    'After every significant information security incident, conduct a post-incident review. Capture lessons learned, update controls and incident response procedures, and track corrective actions through to completion.',
  category: 'incidents',
  scfIds: ['SCF-INC-004'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Post-incident review process or log is published' },
    {
      type: 'manual-attestation',
      description: 'Confirm the post-incident review was actually conducted for recent incidents',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
